import * as React from 'react';
import { Spinner } from '@cian/ui-kit';
import * as styles from './WidgetLoader.css';
export var WidgetLoader = function WidgetLoader() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "widget-loader"
  }, /*#__PURE__*/React.createElement(Spinner, null));
};